import { useMemo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";

import Box from "components/Box";
import ContentSeparator from "components/ContentSeparator";
import MapElement from "components/Map";
import Stack from "components/Stack";
import Text from "components/Text";

import LocationEditButton from "entities/Deal/components/OverviewLocation/LocationEditButton";
import LocationTable from "entities/Deal/components/OverviewLocation/LocationTable";
import { IDeal, useDealCoreData } from "entities/Deal/sdk";

const mapOptions = {
  zoom: 15,
};
interface IOverviewLocation {
  deal: IDeal;
}

const OverviewLocation: React.FC<IOverviewLocation> = ({ deal }) => {
  const { data: dealCoreData } = useDealCoreData({
    dealId: deal.id,
  });

  const markers = useMemo(() => {
    if (
      dealCoreData &&
      deal &&
      deal.address.longitude &&
      deal.address.latitude
    ) {
      const mapMarkers = [
        {
          center: {
            lng: Number(deal.address.longitude),
            lat: Number(deal.address.latitude),
          },
          contentdata: {
            project_name: deal.name,
            address: `${deal.address.street_address}, ${deal.address.city}, ${deal.address.zipcode}`,
            thumbnail: deal.thumbnail,
            units: dealCoreData?.total_units || 0,
          },
        },
      ];

      return mapMarkers;
    }

    return [];
  }, [deal, dealCoreData]);

  return (
    <Box>
      <Stack spacing={2}>
        <Stack direction="row" justifyContent="space-between">
          <Text variant="h2" data-testid="section-header-name">
            Location
          </Text>
          <LocationEditButton />
        </Stack>
        <ContentSeparator label="Location" />
        {deal.address && <LocationTable address={deal.address} />}
        <Box
          sx={{
            height: "400px",
            display: "flex",
            backgroundColor: colors.gray20,
          }}
        >
          {!_.isEmpty(markers) && (
            <MapElement
              options={mapOptions}
              markers={markers}
              showMarkersButton={false}
            />
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default OverviewLocation;
